/* eslint-disable @typescript-eslint/no-loop-func */

import angular from 'angular';
import { DatalayerConstantsType } from 'ib-web-commons/dist/app/core/ib-datalayer/ib-datalayer-constants';
import { DatalayerUtils } from 'src/app/shared/ib-datalayer-utils';
import { AncillariesUtilsService } from '../../../../shared/ib-web-ancillaries-utils';

const controllerInfo = {
    module: 'ib-priority-boarding-module',
    inject: ['$scope', '$rootScope', 'object', 'AncillariesService', '$uibModalInstance', 'localStorageService', 'CurrencyService', 'NewMainHeaderFacade', 'ModalServiceAncillaries', 'AncillariesConstants', 'CommonsAncillariesService', '$timeout', 'DatalayerUtilsService', 'CommonsConstants', 'DatalayerConstants', 'DatalayerUtils', 'AncillariesUtilsService', 'CommonsUtilService'],
    required: []
};

export class PriorityBoardingController implements ng.IController {
    public model;
    public isCurrencyLong;
    public currency;
    public isChecked = true;
    public confirmed = true;
    public amount;
    public totalFormatted;
    public showModalAvios: boolean = false;
    public flightAviosInfo: boolean;
    constructor (
        private $scope: angular.IScope,
        private $rootScope: CommonsRootScope,
        private object: any,
        private AncillariesService: any,
        private $uibModalInstance: ng.ui.bootstrap.IModalInstanceService,
        private localStorageService: angular.local.storage.ILocalStorageService,
        private CurrencyService: CurrencyService,
        private NewMainHeaderFacade: any,
        private ModalServiceAncillaries: any,
        private AncillariesConstants: AncillariesConstant,
        private CommonsAncillariesService: CommonsAncillariesService,
        private $timeout: ng.ITimeoutService,
        private DatalayerUtilsService: DatalayerUtilsService,
        private CommonsConstants: CommonsConstantsType,
        private DatalayerConstants: DatalayerConstantsType,
        private DatalayerUtils: DatalayerUtils,
        private AncillariesUtilsService: AncillariesUtilsService,
        private CommonsUtilService: CommonsUtilService) {
        this.model = this.object.model;
        this.currency = localStorageService.get('currency');
        this.isCurrencyLong = this.object.isCurrencyLong;
        this.$scope.$on('checkChildsWithoutCompanion', this.checkChildsWithoutCompanion);
        this.$rootScope.$on('updatedPriorityInfoModel', this.updatedPriorityInfoModel);
        this.flightAviosInfo = this.AncillariesUtilsService.validatedFlightAviosInfo();
    }

    $onInit (): void {
        let amountTotalPrice = 0,
            isCheckedAllPassengers = false;
        this.confirmed = true;
        isCheckedAllPassengers = this.localStorageService.get('isCheckedAllPassengers');
        amountTotalPrice = this.localStorageService.get('totalPricePriorityBoarding');
        this.amount = amountTotalPrice;
        if (isCheckedAllPassengers !== null) {
            this.isChecked = isCheckedAllPassengers;
        }
        this.totalFormatted = this.CurrencyService.formatPrice(this.currency, amountTotalPrice, true, false, false);
        this.DatalayerUtils.getAncillariesDigitalDataEcommerce('priority boarding', this.DatalayerConstants.EVENTS_ECOMMERCE.VIEW_ITEM_LIST);
        this.$timeout(() => {
            this.updateDataLayerAndDigitalData(false);
        });
        // show modal avios link
        this.amount > 0 ? (this.showModalAvios = true) : (this.showModalAvios = false);
    }

    updateDataLayerAndDigitalData = (backToAnc, accepted = false): void => {
        let quadrigam = this.CommonsConstants.QUADRIGAM.MODAL_SELECT_PRIO;
        if (backToAnc) {
            const flow = this.localStorageService.get('flowApp');
            switch (flow) {
                    case this.AncillariesConstants.APPLICATION_FLOW.BBOOKING:
                    case this.AncillariesConstants.APPLICATION_FLOW.BOOKING:
                        quadrigam = this.CommonsConstants.STEP_FLOW.ANCILLARIES.toUpperCase();
                        break;
                    case this.AncillariesConstants.APPLICATION_FLOW.CHECKIN:
                        quadrigam = this.AncillariesConstants.QUADRIGAM.ANCILLARIES;
                        break;
            }
        }
        if (!backToAnc) {
            this.DatalayerUtilsService.updateDatalayerActionForAncillaries('elegir prioridad', 'click', 'anadir');
        } else if (accepted) {
            this.DatalayerUtilsService.updateDatalayerActionForAncillaries('confirmar prioridad', 'clic', 'confirmar');
        }
        /* INIT DELETE GA4 MIGRATION */
        this.DatalayerUtilsService.updateDatalayerWithQuadrigam(quadrigam, null, this.localStorageService.get('userLogged'));
        this.DatalayerUtilsService.sendDatalayerEvent(this.DatalayerConstants.DATALAYER_EVENT_TYPES.VIEW);
        /* FINISH DELETE GA4 MIGRATION*/
        this.DatalayerUtilsService.updateDigitalDataWithQuadrigam(quadrigam, null, this.localStorageService.get('userLogged'));
        this.DatalayerUtilsService.updateDatalayerViewEvent();
        this.AncillariesUtilsService.isMMBFlow() && this.CommonsUtilService.setTitlePage('MMB_UPDATE_BOARDING_PRIORITY_MODAL_TITLE');
        this.AncillariesUtilsService.isBookingFlow() ?
            this.DatalayerUtilsService.setProcessAndStep(this.CommonsUtilService.getProcess(), null, quadrigam) :
            this.DatalayerUtilsService.setProcessAndStep(this.DatalayerConstants.DATALAYER_ANCILLARIES.ANCILLARIES, null, quadrigam);
        this.DatalayerUtilsService.updateDatalayerViewEvent();
        if (backToAnc) {
            this.DatalayerUtilsService.addDigitalDataInfo({Step: this.DatalayerConstants.DATALAYER_ANCILLARIES.ANCILLARIES});
        } else {
            this.DatalayerUtils.getAncillariesDigitalDataEcommerce('priority', 'view_item_list');
        }
        this.$rootScope.$broadcast('updateDatalayer');
        this.$rootScope.$broadcast('updateDigitalData');
        this.$rootScope.$broadcast('sendUpdateToMonetate');
    };

    close = (): void => {
        const flow = this.localStorageService.get('flowApp');
        this.$uibModalInstance.dismiss();
        if(flow !== this.AncillariesConstants.APPLICATION_FLOW.MMB) {
            this.updateDataLayerAndDigitalData(true, false);
        }
    };

    accept = (): void => {
        const flow = this.localStorageService.get('flowApp');
        let segments: any = {},
            deletePriorityInfo: any = {};
        const deletePriority = [],
            update: any = [
                {
                    type: this.AncillariesConstants.TYPE_ANCILLARIE.PRIORITY_BOARDING,
                    segments: []
                }
            ];
        if (this.model.info) {
            segments = this.createUpdatedInfo();
            if (segments !== 'mostrarModal') {
                this.DatalayerUtils.setPriorityBoardingAddToCart(segments, this.model.info);
                if (segments.length > 0) {
                    update[0].segments = segments;
                    this.localStorageService.set('prioritySegmentPutRequest', segments);
                    this.ModalServiceAncillaries.showWaitingModal();
                    this.CommonsAncillariesService.updateAncillaries(update).then(
                        (data) => {
                            if (!this.confirmed) {
                                this.model.confirmed = false;
                            } else {
                                this.model.confirmed = true;
                            }
                            const ancillariesPriorityBoarding =
                                this.localStorageService.get('genAviosAncillariesPriority');
                            this.AncillariesService.getAviosAncillariesSummaryReq(
                                ancillariesPriorityBoarding,
                                this.AncillariesConstants.TYPE_ANCILLARIE.PRIORITY_BOARDING
                            );
                            this.ModalServiceAncillaries.isNotWaiting();
                            this.NewMainHeaderFacade.updateBasketPriority(this.model.info);

                        },
                        (error) => {
                            this.model.confirmed = false;
                            this.model.selectedPriorityBoarding = null;
                            this.ModalServiceAncillaries.isNotWaiting();
                            this.ModalServiceAncillaries.showGenericError(error).result.then(
                                angular.noop,
                                angular.noop
                            );
                        }
                    );
                } else {
                    deletePriorityInfo = this.createDeleteInfofromModal();
                    if (deletePriorityInfo.segments.length > 0) {
                        //$rootScope.$broadcast('cleanPriorityBoarding');
                        this.confirmed = false;
                        deletePriority.push(deletePriorityInfo);
                        this.localStorageService.set('deletePriority', deletePriority);
                        this.ModalServiceAncillaries.showWaitingModal();
                        this.CommonsAncillariesService.deleteAncillarie(deletePriority).then(
                            (data) => {
                                this.model.confirmed = false;
                                this.NewMainHeaderFacade.updateBasketPriority(this.model.info);
                                this.ModalServiceAncillaries.isNotWaiting();
                            },
                            (error) => {
                                this.model.confirmed = false;
                                this.model.selectedPriorityBoarding = null;
                                this.ModalServiceAncillaries.isNotWaiting();
                                this.ModalServiceAncillaries.showGenericError(error).result.then(
                                    angular.noop,
                                    angular.noop
                                );
                            }
                        );
                    }
                }
            } else {
                this.ModalServiceAncillaries.openWarningChildInfoModal();
            }
        }
        if (segments !== 'mostrarModal') {
            this.localStorageService.set('selectedPriorityBoarding', this.model.info);
            this.localStorageService.set('isCheckedAllPassengers', this.isChecked);
            this.$uibModalInstance.dismiss();
        }
        if(flow !== this.AncillariesConstants.APPLICATION_FLOW.MMB) {
            this.updateDataLayerAndDigitalData(true, false);
        }
    };

    /**
     * Open modal for show know more information
     * @param {String} description Name of piece selected
     * @param {String} subtype Type of piece selected
     */
    openPriorityKnowMoreInformation = (): void => {
        this.ModalServiceAncillaries.openModalPriorityKnowMoreInformation();
    };
    checkChildsWithoutCompanion = (evt: any, status: any): void => {
        let i, j, childsIn = false, adultsIn = false, NumChildsUncheckedTrip0 = 0, NumAdultsUncheckedTrip0 = 0, NumChildsCheckedTrip0 = 0, NumAdultsCheckedTrip0 = 0;
        let childWithCompanionWithPrio, NumChildsUncheckedTrip1 = 0, NumChildsCheckedTrip1 = 0, NumAdultsUncheckedTrip1 = 0, NumAdultsCheckedTrip1 = 0;

        if(!this.isChecked) {
            for (i = 0; i < this.model.info.length; i++) {
                if (this.model.info[i].passengerType === 'CHILD') {
                    childsIn = true;
                }else if (this.model.info[i].passengerType === 'ADULT') {
                    adultsIn = true;
                }
            }
            this.model.info.forEach((passenger: any) => {
                if(passenger.passengerType === 'CHILD') {
                    childsIn = true;
                    if( passenger?.trips[0].checkedTrip === false ) {
                        NumChildsUncheckedTrip0++;
                    }else {
                        NumChildsCheckedTrip0++;
                    }
                    if( passenger?.trips[1] && passenger?.trips[1].checkedTrip === false ) {
                        NumChildsUncheckedTrip1++;
                    }else {
                        NumChildsCheckedTrip1++;
                    }
                }
                if(passenger.passengerType === 'ADULT') {
                    adultsIn = true;
                    if( passenger?.trips[0]?.checkedTrip === false ) {
                        NumAdultsUncheckedTrip0++;
                    }else {
                        NumAdultsCheckedTrip0++;
                    }
                    if( passenger?.trips[1]?.checkedTrip === false ) {
                        NumAdultsUncheckedTrip1++;
                    }else {
                        NumAdultsCheckedTrip1++;
                    }
                }
            });
            if(( ((childsIn && adultsIn) && (NumChildsUncheckedTrip0 >= 1 && NumAdultsUncheckedTrip0 === 0)) || ((childsIn && adultsIn) && NumChildsCheckedTrip0 >= 1 && NumAdultsCheckedTrip0 === 0)) ||
                 ((childsIn && adultsIn) && (NumChildsUncheckedTrip1 >= 1 && NumAdultsUncheckedTrip1 === 0)) || ((childsIn && adultsIn) && NumChildsCheckedTrip1 >= 1 && NumAdultsCheckedTrip1 === 0)) {
                if((childsIn && adultsIn) && ((NumChildsUncheckedTrip0 >= 1 && NumAdultsUncheckedTrip0 === 0) || (NumChildsUncheckedTrip1 >= 1 && NumAdultsUncheckedTrip1 === 0))) {
                    childWithCompanionWithPrio = false;
                    for (i = 0; i < this.model.info.length; i++) {
                        for (j = 0; j < this.model.info[i].trips.length; j++) {
                            if (
                                status.tripInfo.id === this.model.info[i].trips[j].id &&
                                this.model.info[i].trips[j].status !== 'PURCHASED' && childWithCompanionWithPrio === false
                            ) {
                                if(this.model.info[i].passengerType === 'CHILD' && this.model.info[i].trips[j].checkedTrip === false && status.status === true && (NumChildsUncheckedTrip0 >= 1 && NumAdultsUncheckedTrip0 === 0)) {
                                    this.model.info[i].trips[0].checkedTrip = true;
                                    status.status = true;
                                    this.refreshPriorityModalPrice(status);
                                }else if(!childWithCompanionWithPrio && this.model.info[i].passengerType === 'ADULT' && this.model.info[i].trips[j].checkedTrip === true && status.status === false && (NumChildsUncheckedTrip0 >= 1 && NumAdultsUncheckedTrip0 === 0)) {
                                    this.model.info[i].trips[0].checkedTrip = false;
                                    status.status = false;
                                    this.refreshPriorityModalPrice(status);
                                    childWithCompanionWithPrio = true;
                                }
                                if(this.model.info[i].passengerType === 'CHILD' && this.model.info[i].trips[j].checkedTrip === false && status.status === true && (NumChildsUncheckedTrip1 >= 1 && NumAdultsUncheckedTrip1 === 0)) {
                                    this.model.info[i].trips[1].checkedTrip = true;
                                    status.status = true;
                                    this.refreshPriorityModalPrice(status);
                                }else if(!childWithCompanionWithPrio && this.model.info[i].passengerType === 'ADULT' && this.model.info[i].trips[j].checkedTrip === true && status.status === false && (NumChildsUncheckedTrip1 >= 1 && NumAdultsUncheckedTrip1 === 0)) {
                                    this.model.info[i].trips[1].checkedTrip = false;
                                    status.status = false;
                                    this.refreshPriorityModalPrice(status);
                                    childWithCompanionWithPrio = true;
                                }
                            }
                        }
                    }
                    this.refreshPriorityModalPrice(status);
                }
                if ((childsIn && adultsIn) && ((NumChildsCheckedTrip0 >= 1 && NumAdultsCheckedTrip0 === 0) || (NumChildsCheckedTrip1 >= 1 && NumAdultsCheckedTrip1 === 0))) {
                    childWithCompanionWithPrio = false;
                    for (i = 0; i < this.model.info.length; i++) {
                        for (j = 0; j < this.model.info[i].trips.length; j++) {
                            if (
                                status.tripInfo.id === this.model.info[i].trips[j].id &&
                                this.model.info[i].trips[j].status !== 'PURCHASED' && childWithCompanionWithPrio === false
                            ) {
                                if(!childWithCompanionWithPrio && this.model.info[i].passengerType === 'ADULT' && this.model.info[i].trips[j].checkedTrip === false && status.status === true && (NumChildsCheckedTrip0 >= 1 && NumAdultsCheckedTrip0 === 0)) {
                                    this.model.info[i].trips[0].checkedTrip = true;
                                    status.status = true;
                                    this.refreshPriorityModalPrice(status);
                                    childWithCompanionWithPrio = true;
                                }else if(this.model.info[i].passengerType === 'CHILD' && this.model.info[i].trips[j].checkedTrip === true && status.status === false && (NumChildsCheckedTrip0 >= 1 && NumAdultsCheckedTrip0 === 0)) {
                                    this.model.info[i].trips[0].checkedTrip = false;
                                    status.status = false;
                                    this.refreshPriorityModalPrice(status);
                                }
                                if(!childWithCompanionWithPrio && this.model.info[i].passengerType === 'ADULT' && this.model.info[i].trips[j].checkedTrip === false && status.status === true && (NumChildsCheckedTrip1 >= 1 && NumAdultsCheckedTrip1 === 0)) {
                                    this.model.info[i].trips[1].checkedTrip = true;
                                    status.status = true;
                                    this.refreshPriorityModalPrice(status);
                                    childWithCompanionWithPrio = true;
                                }else if(this.model.info[i].passengerType === 'CHILD' && this.model.info[i].trips[j].checkedTrip === true && status.status === false && (NumChildsCheckedTrip1 >= 1 && NumAdultsCheckedTrip1 === 0)) {
                                    this.model.info[i].trips[1].checkedTrip = false;
                                    status.status = false;
                                    this.refreshPriorityModalPrice(status);
                                }
                            }
                        }
                    }
                    this.refreshPriorityModalPrice(status);
                }
                this.ModalServiceAncillaries.openWarningChildInfoModal();
            } else {
                this.refreshPriorityModalPrice(status);
            }
        }else {
            this.refreshPriorityModalPrice(status);
        }
    };

    refreshPriorityModalPrice = (status: any): void => {
        let i, j;
        const passengers = this.model.info.length,
            offer = status.tripInfo.amount;
        if (status.status) {
            if (this.isChecked) {
                for (i = 0; i < this.model.info.length; i++) {
                    for (j = 0; j < this.model.info[i].trips.length; j++) {
                        if (
                            status.tripInfo.id === this.model.info[i].trips[j].id &&
                            this.model.info[i].trips[j].status !== 'PURCHASED'
                        ) {
                            this.model.info[i].trips[j].checkedTrip = true;
                            this.amount += this.model.info[i].trips[j].amount;
                        }
                    }
                }
                this.totalFormatted = this.CurrencyService.formatPrice(this.currency, this.amount, true, false, false);
            } else {
                this.amount += offer;
                this.totalFormatted = this.CurrencyService.formatPrice(this.currency, this.amount, true, false, false);
            }
        } else {
            if (this.isChecked) {
                for (i = 0; i < this.model.info.length; i++) {
                    for (j = 0; j < this.model.info[i].trips.length; j++) {
                        if (
                            status.tripInfo.id === this.model.info[i].trips[j].id &&
                            this.model.info[i].trips[j].status !== 'PURCHASED'
                        ) {
                            this.model.info[i].trips[j].checkedTrip = false;
                            this.amount -= this.model.info[i].trips[j].amount;
                        }
                    }
                }
                this.totalFormatted = this.CurrencyService.formatPrice(this.currency, this.amount, true, false, false);
            } else {
                this.amount -= offer;
                this.totalFormatted = this.CurrencyService.formatPrice(this.currency, this.amount, true, false, false);
            }
        }
        this.localStorageService.set('totalPricePriorityBoarding', this.amount);
        // mostrar u ocultar modal avios
        this.amount > 0 ? (this.showModalAvios = true) : (this.showModalAvios = false);
        const genTransformTripsPriority = this.AncillariesService.genTripsAncillaries(this.model.info);
        this.AncillariesService.getReqAviosAncillariesPriorityBoarding(genTransformTripsPriority);
        status.tripInfo.numPassengers = (this.isChecked && this.model?.info && this.model.info.length) ? this.model.info.length : 0;
        this.DatalayerUtils.setPriorityBoardingSelectItem(status.tripInfo);
    };

    createUpdatedInfo = () => {
        let i, j, k, position;
        const segments = [];
        for (i = 0; i < this.model.info.length; i++) {
            for (j = 0; j < this.model.info[i].trips.length; j++) {
                position = {};
                if (this.model.info[i].trips[j].checkedTrip === true) {
                    position = searchSegment(this.model.info[i].trips[j].id, segments);
                    if (angular.isUndefined(position)) {
                        segments.push({
                            id: this.model.info[i].trips[j].id,
                            passengerIds:
                                this.model.info[i].trips[j].status === 'AVAILABLE' ? [this.model.info[i].id] : []
                        });
                    } else {
                        for (k = 0; k < segments.length; k++) {
                            if (segments[k].id === position.id) {
                                if (this.model.info[i].trips[j].status === 'AVAILABLE') {
                                    segments[k].passengerIds.push(this.model.info[i].id);
                                }
                            }
                        }
                    }
                }
            }
        }

        return segments;

        function searchSegment (segmentsId, segments) {
            let i;
            for (i = 0; i < segments.length; i++) {
                if (segments[i].id === segmentsId) {
                    return segments[i];
                }
            }
        }
    };

    clickCheckAllPassengers = (): void => {
        let position;
        if (this.isChecked) {
            this.amount = 0;
            this.totalFormatted = this.CurrencyService.formatPrice(this.currency, this.amount, true, false, false);
            for (position = 0; position < this.model.info[0].trips.length; position++) {
                if (this.model.info[0].trips[position].checkedTrip === true) {
                    angular.forEach(this.model.info, (passenger) => {
                        passenger.trips[position].checkedTrip = true;
                        this.amount += passenger.trips[position].amount;
                        this.totalFormatted = this.CurrencyService.formatPrice(
                            this.currency,
                            this.amount,
                            true,
                            false,
                            false
                        );
                    });
                } else {
                    angular.forEach(this.model.info, (passenger) => {
                        passenger.trips[position].checkedTrip = false;
                    });
                }
            }
        } else {
            this.isChecked;
        }
    };

    updatedPriorityInfoModel = (evt: any, deletePriorityInfo: any): void => {
        let i,
            j,
            amount = 0;
        const idDeleteSegment = deletePriorityInfo[0]?.segments[0]?.id || null;
        this.localStorageService.set('totalPricePriorityBoarding', 0);
        for (i = 0; i < this.model.info.length; i++) {
            for (j = 0; j < this.model.info[i].trips.length; j++) {
                if (idDeleteSegment === this.model.info[i].trips[j].id) {
                    this.model.info[i].trips[j].checkedTrip = false;
                } else {
                    if (this.model.info[i].trips[j].checkedTrip) {
                        amount += amount;
                    }
                }
            }
        }
        this.AncillariesService.deleteAviosAncillaries(idDeleteSegment, this.AncillariesConstants.TYPE_ANCILLARIE.PRIORITY_BOARDING);
        this.localStorageService.set('totalPricePriorityBoarding', amount);
    };

    checkWarningModal = (): any => {
        let warningModal = false,
            i,
            j,
            tripsInfoAux = {
                idSegment: '',
                adultsAdd: 0,
                childsAdd: 0,
                adultsWithout: 0,
                childsWithout: 0,
                totalPassengers: 0
            },
            found: any = {},
            id;
        const auxInfo = [];
        for (i = 0; i < this.model.info.length; i++) {
            for (j = 0; j < this.model.info[i].trips.length; j++) {
                found = {};
                found = searchIdSegments(this.model.info[i].trips[j].id, auxInfo);
                if (angular.isUndefined(found)) {
                    tripsInfoAux = {
                        idSegment: '',
                        adultsAdd: 0,
                        childsAdd: 0,
                        adultsWithout: 0,
                        childsWithout: 0,
                        totalPassengers: 0
                    };
                    tripsInfoAux.idSegment = this.model.info[i].trips[j].id;
                    if (this.model.info[i].trips[j].checkedTrip || this.model.info[i].trips[j].status === 'PURCHASED') {
                        if (this.model.info[i].passengerType === 'CHILD') {
                            tripsInfoAux.childsAdd++;
                            tripsInfoAux.totalPassengers++;
                        } else {
                            tripsInfoAux.adultsAdd++;
                            tripsInfoAux.totalPassengers++;
                        }
                    } else {
                        if (this.model.info[i].passengerType === 'CHILD') {
                            tripsInfoAux.childsWithout++;
                            tripsInfoAux.totalPassengers++;
                        } else {
                            tripsInfoAux.adultsWithout++;
                            tripsInfoAux.totalPassengers++;
                        }
                    }
                    auxInfo.push(tripsInfoAux);
                } else {
                    if (this.model.info[i].trips[j].checkedTrip || this.model.info[i].trips[j].status === 'PURCHASED') {
                        if (this.model.info[i].passengerType === 'CHILD') {
                            found.childsAdd++;
                            found.totalPassengers++;
                        } else {
                            found.adultsAdd++;
                            found.totalPassengers++;
                        }
                    } else {
                        if (this.model.info[i].passengerType === 'CHILD') {
                            found.childsWithout++;
                            found.totalPassengers++;
                        } else {
                            found.adultsWithout++;
                            found.totalPassengers++;
                        }
                    }
                }
            }
        }
        for (i = 0; i < auxInfo.length; i++) {
            if (auxInfo[i].childsAdd >= auxInfo[i].adultsAdd + 1 && auxInfo[i].adultsAdd === 0) {
                warningModal = true;
            } else if (
                auxInfo[i].childsAdd < auxInfo[i].adultsAdd &&
                auxInfo[i].childsWithout > auxInfo[i].adultsWithout
            ) {
                warningModal = true;
            }
        }
        return warningModal;

        function searchIdSegments (segmentsId, segments) {
            let i;
            for (i = 0; i < segments.length; i++) {
                if (segments[i].idSegment === segmentsId) {
                    return segments[i];
                }
            }
        }
    };

    createDeleteInfofromModal = (): any => {
        let i,
            j,
            k,
            segmentAux = { id: '', passengerIds: [] },
            isSegmentToDelete = false,
            bfound = false;
        const tempPriorityBoardingInfo = this.localStorageService.get('selectedPriorityBoarding');
        const deleteStructure = {
            type: 'PRIORITY_BOARDING',
            segments: []
        };
        if (tempPriorityBoardingInfo) {
            for (i = 0; i < this.model.info.length; i++) {
                for (j = 0; j < this.model.info[i].trips.length; j++) {
                    if (
                        this.model.info[i].trips[j].status === this.AncillariesConstants.STATUS.AVAILABLE &&
                        !this.model.info[i].trips[j].checkedTrip
                    ) {
                        isSegmentToDelete = checkIfDelete(
                            tempPriorityBoardingInfo,
                            this.model.info[i].trips[j].id,
                            this.model.info[i].id
                        );
                        if (isSegmentToDelete) {
                            bfound = false;
                            segmentAux = { id: '', passengerIds: [] };
                            segmentAux.id = this.model.info[i].trips[j].id;
                            segmentAux.passengerIds.push(this.model.info[i].id);
                            for (k = 0; k < deleteStructure.segments.length; k++) {
                                if (deleteStructure.segments[k].id === segmentAux.id) {
                                    bfound = true;
                                    deleteStructure.segments[k].passengerIds.push(segmentAux.passengerIds[0]);
                                }
                            }
                            if (!bfound) {
                                deleteStructure.segments.push(segmentAux);
                            }
                        }
                    }
                }
            }
        }
        return deleteStructure;

        function checkIfDelete (tempPriorityBoardingInfo, idSegment, idPassenger) {
            let i,
                j,
                addToDelete = false;
            for (i = 0; i < tempPriorityBoardingInfo.length; i++) {
                if (tempPriorityBoardingInfo[i].id === idPassenger) {
                    for (j = 0; j < tempPriorityBoardingInfo[i].trips.length; j++) {
                        if (
                            tempPriorityBoardingInfo[i].trips[j].id === idSegment &&
                            tempPriorityBoardingInfo[i].trips[j].checkedTrip
                        ) {
                            addToDelete = true;
                        }
                    }
                }
            }
            return addToDelete;
        }
    };
    /*
     ** open modal avios
     */
    openModalAviosPrioAncillaries = (): any => {
        this.AncillariesService.manageAviosModal(this.localStorageService.get('genAviosAncillariesPriority'));
    };
}


try {
    PriorityBoardingController.$inject = controllerInfo.inject;
    angular.module(controllerInfo.module).controller(PriorityBoardingController.name, PriorityBoardingController);

} catch (error) {
    const mod = angular.module(controllerInfo.module, controllerInfo.required);
    PriorityBoardingController.$inject = controllerInfo.inject;
    mod.controller(PriorityBoardingController.name, PriorityBoardingController);
}